import { Market } from '@org-avp/models';
import { GiveawayResponse } from '@org-avp/avp-hck-dga-customerui-commons';

export const requiresEnergyEfficiencyLabel = (data: GiveawayResponse) => {
  return (
    [Market.FRA, Market.CHE].includes(data.market) &&
    data.consumptionAndEmissionData?.eec !== undefined
  );
};
